module.exports = __webpack_public_path__ + "media/packs/booking-system/appointment-booking/src/images/Clock-dd300361f380db653be25620a4f9159c.svg";